var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('c-preloader',{attrs:{"isLoading":_vm.isLoading,"bgcolor":"rgb(58 42 79)"}}):_vm._e(),_c('c-nav'),_c('div',{staticClass:"page-content-container"},[_c('router-view')],1),_c('c-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }